<template>
  <v-container background fluid pa-3  class="contain_width">
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <!-- <v-tooltip top> -->
          <v-btn
           
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <!-- <span>{{$t('create')}}</span>
        </v-tooltip> -->
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer" v-if="permission_edit == true || admin == 'true'">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:200px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddBranch')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('AddBranch')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg2 md4 sm4 xs12 v-for="(item, index) in table_data" :key="index" @click="''">
          <v-card class=" box-branch " >
               <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-center">
              <v-menu offset-y>
                  <template  slot="activator" >
                    <v-btn icon>
                            <v-icon small>fas fa-ellipsis-v</v-icon>
                          </v-btn> 
                  </template>
                  <v-card class="pa-0" max-width="344">
                      <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'"> 
                        <v-btn slot="activator" color="warning"  flat @click="onHandleDialog(true,'update',item)">
                            <v-icon>edit</v-icon>
                            <span>{{$t('edit')}}</span>
                        </v-btn>
                      </v-card-title>
                      <v-card-title  class="setbox" v-if="permission_edit == true || admin == 'true'">
                          <v-btn slot="activator" color="error"  flat @click="deleteItem(item)">
                            <v-icon>close</v-icon>
                            <span>{{$t('delete')}}</span>
                          </v-btn>
                      </v-card-title>
                  </v-card>
              </v-menu>
              </div>
            </v-card-actions>
              <v-card-title >
                <v-layout row warp style="margin-top:-25px;">
                    <v-flex lg12 md12 sm12 xs12 text-xs-center>
                    <v-avatar>
                    <v-icon size="64" color="primary" style="cursor: pointer;" >fas fa-building</v-icon>
                  </v-avatar>
                  
                    </v-flex>
                </v-layout>

              </v-card-title>
               <v-card-title>
                 <v-layout row wrap >
                    <v-flex lg4 offset-lg2 md4 offset-md2 sm4 offset-sm2 xs4 offset-xs2>
                      <span class="coco-list-label-text">{{$t('branch_code')}} : </span>
                    </v-flex>
                     <v-flex lg5 offset-lg1 md5 offset-md1 sm5 offset-sm1 xs5 offset-xs1>
                      <span>{{isEmpty(item.code)? item.code : '-'}}</span>
                    </v-flex>
                    <v-flex lg4 offset-lg2 md4 offset-md2 sm4 offset-sm2 xs4 offset-xs2>
                      <span class="coco-list-label-text">{{$t('branch')}} :</span>
                    </v-flex>
                    <v-flex lg5 offset-lg1 md5 offset-md1 sm5 offset-sm1 xs5 offset-xs1>
                      <span v-html="' <span>'+(isEmpty(item.name) ? item.name : 'name')+'</span>'"/>
                    </v-flex>
                     <v-flex lg4 offset-lg2 md4 offset-md2 sm4 offset-sm2 xs4 offset-xs2>
                      <span class="coco-list-label-text">{{$t('remark') + ': '}} </span>
                    </v-flex>
                    <v-flex lg5 offset-lg1 md5 offset-md1 sm5 offset-sm1 xs5 offset-xs1>
                        <span> {{isEmpty(item.remark)? item.remark : '-'}} </span>
                    </v-flex>
                </v-layout>
              </v-card-title>
  </v-card>
          <!-- <v-card class="coco-box-shadow coco-list-hover">
              <v-layout align-center justify-center row fill-height wrap class="coco-list-layout" style=" padding-top: 10px;">
               <v-flex lg9 md9 sm8 xs9>
                  <v-layout row wrap>
                    <v-flex lg2 md4 sm6 xs12>
                      <span class="coco-list-label-text">{{isEmpty(item.code)? item.code : 'code'}}:</span>
                      <span
                        v-html="' <span>'+(isEmpty(item.name) ? item.name : 'name')+'</span>'"
                      />
                    </v-flex>
                    <v-flex lg2 md4 sm6 xs12>
                      <span class="coco-list-label-text">
                        {{$t('remark') + ': '}}
                        <span>
                          {{isEmpty(item.remark)?
                          item.remark : 'remark'}}
                        </span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md2 sm2 class="hidden-xs-only">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-xs8 xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                 <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-card> -->
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
              <v-spacer/>
                <v-btn icon dark @click="delDialogStatus = false">
                  <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
              <v-layout row wrap pa-3>
                <v-flex xs12>
                  <v-card-text>
                    ต้องการลบข้อมูลสาขา
                    <br>
                    รหัส:{{delDialog.code}}
                    <br>
                    ชื่อ:{{delDialog.name}} ใช่หรือไม่?
                  </v-card-text>
                </v-flex>
              </v-layout>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog"/>
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import SettingService from "@/services/SettingService";
import UserService from "@/services/UserService";
import Utils from "@/utils/";
import FrmDialog from "./FormDialog";

export default {
  data: () => ({
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      code: "",
      name: ""
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    permission_edit :false,
    permission_view :false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("BranchList");
    console.log(this.check_permission)
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.getProfileBranchList();
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    FrmDialog
  },
  computed: {
    ...mapState("app", ["showLoading"]),
   // ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      this.getProfileBranchList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getProfileBranchList();
        }
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getProfileBranchList() {
      this.commitSetShowLoading(true);
      var detail = [];
      SettingService.getProfileBranchList(this.pageActive)
        .then(res => {
          this.table_data = res.data.content;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.code = data.code;
      this.delDialog.name = data.name;
      this.delDialogStatus = true;
    },
    onDelete() {
      SettingService.deleteProfileBranch(this.delDialog.code)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getProfileBranchList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span {
  font-family: "Prompt", sans-serif;
}
.content {
  margin-top: 5px;
  margin-bottom: 5px;
}
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
  }
@media screen and (min-width: 1366px){
.box-branch{
  width: 100% !important;
  height: 250px !important;
  border-radius: 10px!important;
  background-color: #ffffff ;
  margin:10px;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: left;
}
}
/* mobile  ----------- */
@media screen and  (max-width: 812px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
  .box-branch{
  width: 95% !important;
  height: 250px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 1em;
 
}
  
}
 
.font-menu{
  font-size: 0.5rem ;
}
.icon-menu{
  font-size: 2rem ;
}
/* tablet  ----------- */
@media screen and (min-width: 768px) and (max-width: 1024px){
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  .box-branch{
  width: 95% !important;
  height: 250px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
   font-size: 0.9em;
   
 
}
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
   .box-branch{
  width: 95% !important;
  height: 250px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:10px;
  text-align: left;
 font-size: 1em;
}

}

@media screen and (min-width: 1200px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
   .box-branch{
  width: 95% !important;
  height: 250px !important;
  border-radius: 10px !important;
  background-color: #ffffff ;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  margin:5px;
  text-align: left;
  font-size: 0.9em;
 
}
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
.box-pointer {
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 20px;
}

.box-pointer-vdo {
  cursor: pointer;
}
.avoid-clicks {
  pointer-events: none;
}
.avatar{
height: 64px !important;
width: 64px !important;
}
.showtool{
z-index: 2;
}
</style>